import BottomSheet from '@gorhom/bottom-sheet';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { LayoutChangeEvent } from 'react-native';
import { EarnSubscriptionDetails, UserEarnActionListResponseDataItem } from '@utx/utx-client';
import { AutoRenewalProps } from '../../components/autoRenewal/AutoRenewal.web';
import { RedeemMainProps } from '../redemption/RedeemMain';

export enum SubscriptionDetailsStackRoutes {
  Main = 'main',
  AutoRenew = 'autoRenew',
  Redeem = 'redeem'
}

export type SubscriptionDetailsStackParamList = {
  [SubscriptionDetailsStackRoutes.Main]: {
    subscription: UserEarnActionListResponseDataItem;
    onUpdate: () => void;
    onLayout: (event: LayoutChangeEvent) => void;
  };
  [SubscriptionDetailsStackRoutes.AutoRenew]: AutoRenewalProps;
  [SubscriptionDetailsStackRoutes.Redeem]: RedeemMainProps & { refreshPortfolio: () => void };
};

export type SubscriptionDetailsStackScreenProps<Screen extends keyof SubscriptionDetailsStackParamList> = NativeStackScreenProps<
  SubscriptionDetailsStackParamList,
  Screen
>;
